<template>
    <div class='appLogin'>
        <div class='login-modal'>
            <div class='title'>请登录</div>
            <div class='explain'>登录即可处理新美云待办事项。首次登录成功，系统会自动将您的微信账户与新美云绑定。</div>
            <div class='login-phone'>
                <div class='phone-left' :class='userPhone ? "" : "phone-left-none"'>
                    <input v-model='userPhone' @focus="userPhoneFocus = true" @blur="userPhoneBlur('userPhoneFocus')"
                        placeholder="手机号" type="text" :disabled="switchFlag ? true : false"
                        onkeyup="this.value=this.value.replace(/[^\d\s]/ig,'')" maxlength="13" />
                    <span v-show='userPhone && userPhoneFocus' @click='userPhone = ""' icon='close'></span>
                </div>
                <div class='phone-right' :class='phoneCodeFlag ? "" : "code-disabled"' v-if='!switchFlag' @click='getCode'>
                    {{ btnName }}</div>
                <div class='phone-right' v-if='switchFlag'>已发送({{ countdown }}s)</div>
            </div>
            <div class='login-code' :class='borderNone ? "login-code-border" : ""'>
                <input v-model='userCode' @focus="userCodeFocus = true" @blur="userPhoneBlur('userCodeFocus')"
                    placeholder="验证码" type="text" onkeyup="this.value=this.value.replace(/\D/g,'')" maxlength="6" />
                <span v-show='userCode && userCodeFocus' @click='userCode = ""' icon='clear'></span>
            </div>
        </div>
        <div class='btn' :class='!userPhone || !userCode ? "btn-disabled" : ""' @click='login'>登录</div>
        <!-- <div class='btn'  @click='login'>登录</div> -->
    </div>
</template>
<script>
import { Toast, Dialog } from 'vant';
import * as Urls from '../helper/Urls';
import MenuUtils from '@/utils/MenuUtils'
import allMenu from '../menu/allMenu';
import commonMenu from '../menu/menu';
import * as VueHelper from '../helper/VueHelper';
export default {
    data() {
        return {
            userPhone: '',
            userCode: '',
            userPhoneFocus: false,
            userCodeFocus: false,
            switchFlag: false,
            phoneCodeFlag: false,
            reg: /^[1][3,4,5,7,8,9][0-9]{9}$/,
            data: {
                phoneInfo: '',
                codeInfo: ''
            },
            countdown: 60,
            countDownSet: null,
            borderNone: true,
            btnName: '获取验证码',
            code: ''
        }
    },
    components: {
        Toast, Dialog
    },
    created() {
        let wxOpenId = sessionStorage.getItem('wxOpenId')
        if (!wxOpenId || wxOpenId == 'undefined') {
            this.$router.push('/appLogin/agent')
        }
    },
    watch: {
        userPhone(val, old) {
            this.data.phoneInfo = val;
            this.phoneCodeFlag = this.reg.test(val.replace(/\s*/g, "")) ? true : false;
            if (val.length == 13 && !this.reg.test(val.replace(/\s*/g, ""))) {
                Toast('手机号有误');
            }
            if (val.length > old.length) {
                if (val.length === 3 || val.length === 8) {
                    this.userPhone += ' '
                }
            } else {
                if (val.length === 9 || val.length === 4) {
                    this.userPhone = this.userPhone.trim()
                }
            }
            let arr = val.split('');
            if (arr[3] && arr[3] != ' ') {
                arr.splice(3, 0, ' ')
            }
            if (arr[8] && arr[8] != ' ') {
                arr.splice(8, 0, ' ')
            }
            this.userPhone = arr.join('')
        },
        userCode(val, old) {
            this.data.codeInfo = val;
        }
    },
    methods: {
        getCode() {
            let inst = this;
            let url = Urls.wx_login_code;
            let params = {
                phone: this.userPhone.replace(/\s/g, '')
            }
            this.$root.doGet(url, params, function (server_data) {
                inst.countdown = 60
                inst.switchFlag = true;
                inst.btnName = '重新获取'
                inst.countDownSet = setInterval(() => {
                    if (inst.countdown > 0) {
                        inst.countdown--
                    } else {
                        inst.switchFlag = false;
                        clearInterval(inst.countDownSet)
                    }
                }, 1000)
            })

        },
        userPhoneBlur(type) {
            setTimeout(() => {
                this[type] = false;
                if (type == 'userPhoneFocus' && !this.reg.test(this.userPhone.replace(/\s*/g, ""))) {
                    this.userPhone.replace(/\s*/g, "") == '' ? '' : Toast('手机号有误')
                }
            }, 100);
        },
        login() {
            let inst = this;
            let openId = sessionStorage.getItem('wxOpenId');
            let url = Urls.wx_user_login;
            let params = {
                phone: this.userPhone.replace(/\s/g, ''),
                smsCode: this.userCode,
                openId: openId || '',
            }
            this.$root.doPost(url, params, function (server_data) {
                // 应用错误
                if (server_data.error) {
                    Toast(server_data.error);
                    return;
                }
                sessionStorage.setItem('user', JSON.stringify(server_data.data))
                let role = server_data.data.roleValue;
                console.log("role:" + role);
                // 获取前端的角色的菜单权限
                // let menu = allMenu[role] || [];
                // menu = menu.concat(commonMenu);
                let menu = commonMenu;
                //拼接后台提供的列表路由
                let roleMeun = server_data.data.roleMeun;
                let menuData = [];

                roleMeun.forEach((element, index) => {
                    if (!element.children.length && element.workBenchList.length) {//菜单有一级
                        menuData.push({
                            path: '/p' + index,
                            component: "HomeView",
                            redirect: element.workBenchList[0].benchPath,
                            name: element.menuName,
                            parent: true,
                            children: [
                                {
                                    pageAddress: element.workBenchList[0].benchComponent,
                                    path: element.workBenchList[0].benchPath,
                                    name: element.menuName
                                }
                            ]
                        })
                    } else if (!element.children[0].children.length) {//菜单有二级
                        let data = {
                            path: '/p' + index,
                            redirect: '',
                            component: "HomeView",
                            name: element.menuName,
                            icon: element.menuIcon,
                            parent: true,
                            children: []
                        };
                        element.children.forEach((element2, index2) => {
                            if (!element2.workBenchList.length) return;
                            data.children.push({
                                pageAddress: element2.workBenchList[0].benchComponent,
                                path: element2.workBenchList[0].benchPath,
                                name: element2.menuName,
                                icon: element2.menuIcon,
                            })
                            if (index2 === 0) {
                                data.redirect = element2.workBenchList[0].benchPath;
                            }
                        })

                        menuData.push(data);

                    } else {//菜单有三级
                        let data = {
                            path: '/p' + index,
                            redirect: '',
                            component: "HomeView",
                            name: element.menuName,
                            icon: element.menuIcon,
                            parent: true,
                            children: []
                        };
                        element.children.forEach((element2, index2) => {
                            let data2 = {
                                parent: true,
                                component: "Navigation",
                                path: "/home",
                                name: element2.menuName,
                                icon: element2.menuIcon,
                                children: []
                            }
                            element2.children.forEach((element3, index3) => {
                                if (!element3.workBenchList.length) return;
                                data2.children.push({
                                    pageAddress: element3.workBenchList[0].benchComponent,
                                    path: element3.workBenchList[0].benchPath,
                                    name: element3.menuName,
                                    icon: element3.menuIcon,
                                })
                                if (index2 === 0 && index3 === 0) {
                                    data.redirect = element3.workBenchList[0].benchPath;
                                }

                                //拼接三级内页
                                for (let i = 0; i < menu.length; i++) {
                                    let obj = menu[i];
                                    if (obj.menuId == element.menuCode) {
                                        for (let j = 0; j < obj.children.length; j++) {
                                            let obj2 = obj.children[j];
                                            if (obj2.menuId == element2.menuCode) {
                                                data2.children = data2.children.concat(obj2.children);
                                                break;
                                            }
                                        }
                                    }
                                }
                                // menu.forEach(obj => {
                                //     obj.children.forEach(obj2 => {
                                //         if(obj2.name == element2.menuName && obj.name == element.menuName){
                                //             data2.children = data2.children.concat(obj2.children);
                                //             break;

                                //         }
                                //     })
                                // })

                            })
                            data.children.push(data2);

                        })
                        menuData.push(data);
                    }

                })
                //设置登录之后第一个页面
                if (menuData.length) {
                    menuData[0].path = '/';
                }
                //打印页面
                menu.forEach((element, index) => {
                    if (element.hidden && !element.redirect) {
                        menuData = menuData.concat(element);
                    }
                })




                window.sessionStorage.setItem('userPre', JSON.stringify(menuData))
                let routes = [];
                MenuUtils(routes, menuData)  //  引入组件 和过滤component      
                console.log("登录routes", routes);
                inst.$router.addRoutes(routes);
                sessionStorage.token = server_data.data.token;
                inst.$router.push('/appLogin/agent');//微信代办登录跳转到列表页面
            });
        },
        GetUrlParame(parameName) {
            var parames = window.location.search;
            if (parames.indexOf(parameName) > -1) {
                var parameValue = "";
                parameValue = parames.substring(
                    parames.indexOf(parameName),
                    parames.length
                );
                if (parameValue.indexOf("&") > -1) {
                    parameValue = parameValue.substring(
                        0,
                        parameValue.indexOf("&")
                    );
                    parameValue = parameValue.replace(parameName + "=", "");
                    return parameValue;
                }
                return "";
            }
        }
    },
    beforeDestroy() {
        clearInterval(this.countDownSet)
    },
    destroyed() {
        clearInterval(this.countDownSet)
    }
}
</script>
<style lang="scss" scoped>
$url: 'https://xmyun.zhoty.com/resource/xmwebapp/';

.appLogin {
    height: calc(100vh);
    max-width: 750px;
    background: #eee;
    overflow: hidden;
    font-family: PingFang SC;

    .login-modal {
        background: #fff;
        padding: 0 .15rem;

        .title {
            font-size: 0.28rem;
            font-weight: 500;
            color: #000000;
            height: .28rem;
            line-height: .28rem;
            padding: .42rem 0 .17rem;
        }

        .explain {
            font-size: 0.18rem;
            color: #333333;
            line-height: 0.24rem;
            padding-bottom: .2rem;
        }

        input {
            outline: none;
            border: none;
            height: .5rem;
            font-size: .18rem;
            width: 100%;
            -webkit-box-shadow: 0 0 0 1000px white inset;

            &::-webkit-input-placeholder {
                color: #999;
            }
        }

        .login-phone {
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-bottom: .01rem solid #e5e5e5;

            .phone-left {
                position: relative;

                span {
                    width: .5rem;
                    height: .5rem;
                    position: absolute;
                    top: 0;
                    right: -.2rem;
                    background: url($url+'clear-text.png') no-repeat;
                    background-size: .15rem;
                    background-position: center;
                }
            }

            .phone-left-none {
                // width:100%
            }

            .phone-right {
                font-size: .14rem;
                color: #EC1212;
                border: .01rem solid #EC1212;
                padding: .02rem 0;
                width: .86rem;
                text-align: center;
                border-radius: .02rem;
                flex-shrink: 0;
            }

            .code-disabled {
                color: #EC1212;
                opacity: .5;
                pointer-events: none;
            }
        }

        .login-code {
            margin-top: .1rem;
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-bottom: .01rem solid #e5e5e5;
            position: relative;

            span {
                width: .5rem;
                height: .5rem;
                position: absolute;
                top: 0;
                right: -.16rem;
                background: url($url+'clear-text.png') no-repeat;
                background-size: .15rem;
                background-position: center;
            }

            .span {
                right: .3rem;
            }
        }

        .login-code-border {
            border-bottom: none
        }
    }

    .btn {
        height: 0.5rem;
        color: #fff;
        margin: .4rem .15rem 0;
        background: #EC1212;
        border-radius: .03rem;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 0.18rem;
    }

    .btn-disabled {
        opacity: .5;
        pointer-events: none;
    }
}
</style>
<style lang="scss">
// .van-overlay{
//     background-color: rgba(0,0,0,.3) !important;
// }
// .van-dialog__message{
//         font-weight: bold;
//         font-size: .18rem !important;
//     }
// .van-dialog__content--isolated{
//     min-height: auto !important;
// }
</style>


// WEBPACK FOOTER //
// AppLogin.vue?35c613a8